/*
 * Своя иконка и заглавие за всеки раздел (22.10.2026, Калин) — закачените
 * и запазените страници на Тефтер иначе са еднакво сиво глобусче и не се
 * различават една от друга, нито от чуждите сайтове. Цветно квадратче със
 * знак по раздела; браузърът го запомня и за отметката.
 */
const RAZDELI = [
  ['/documents/new', '🛒', '#0f766e', 'Продажба'],
  ['/chakat-prodazhba', '⏳', '#b45309', 'Чакат продажба'],
  ['/offers', '📝', '#0891b2', 'Оферти'],
  ['/transfer', '🔁', '#4f46e5', 'Прехвърляне'],
  ['/revision', '📋', '#7c3aed', 'Ревизия'],
  ['/returns', '↩️', '#be123c', 'Връщане'],
  ['/invoicing', '🧾', '#0369a1', 'Фактуриране'],
  ['/purchase-orders', '📦', '#a16207', 'Поръчки'],
  ['/deliveries', '🚚', '#15803d', 'Доставки до клиенти'],
  ['/services', '🔧', '#475569', 'Услуги'],
  ['/documents', '📄', '#334155', 'Документи'],
  ['/cash', '💶', '#166534', 'Каса'],
  ['/payments', '💳', '#1d4ed8', 'Плащания'],
  ['/debtors', '⚖️', '#b91c1c', 'Длъжници'],
  ['/reports', '📊', '#6d28d9', 'Справки'],
  ['/profit', '📈', '#047857', 'Печалба'],
  ['/stock', '🏷️', '#0e7490', 'Наличности'],
  ['/partners', '👥', '#9333ea', 'Контрагенти'],
  ['/price-lists', '💲', '#c2410c', 'Ценови листи'],
  ['/mail', '✉️', '#0284c7', 'Поща'],
  ['/payroll', '💰', '#854d0e', 'Заплати'],
  ['/audit', '🔍', '#52525b', 'Одитен дневник'],
  ['/users', '🔑', '#52525b', 'Потребители'],
  ['/settings', '⚙️', '#52525b', 'Настройки'],
  ['/fiscal', '🖨️', '#52525b', 'Фискални устройства'],
];
// Началото и всичко без свой раздел — логото на Тефтер (тефтер с „Т“),
// същото като /favicon.ico, което браузърът слага на отметките.
const NACHALO = [null, null, null];

function svg(znak, cvyat) {
  return 'data:image/svg+xml,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">'
    + `<rect width="64" height="64" rx="14" fill="${cvyat}"/>`
    + `<text x="32" y="46" font-size="40" text-anchor="middle">${znak}</text></svg>`);
}

export function setRazdelIcon(pathname) {
  if (pathname.startsWith('/print/')) return;
  const r = RAZDELI.find(([p]) => pathname === p || pathname.startsWith(`${p}/`) || pathname.startsWith(`${p}?`));
  const [znak, cvyat, ime] = r ? r.slice(1) : NACHALO;
  document.querySelectorAll('link[rel="icon"]').forEach((l, i) => { if (i > 0) l.remove(); });
  let link = document.querySelector('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.removeAttribute('sizes');
  link.type = znak ? 'image/svg+xml' : 'image/png';
  link.href = znak ? svg(znak, cvyat) : '/favicon-192.png';
  document.title = ime ? `${ime} — Тефтер` : 'Тефтер — Доктор Принтер';
}
